import _ from "lodash";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Afribrand from "../../assets/images/afriglobal.svg";
import BrandImage from "../../assets/images/brandImage.svg";
import Clinixbrand from "../../assets/images/clinix.svg";
import arivealive from "../../assets/images/arivealive.png";
import broadplace from "../../assets/images/broadplaces.png";
import DisableRight from "../../assets/images/DisableRight.svg";
import Dnabrand from "../../assets/images/dna.svg";
import HomeDisable from "../../assets/images/HomeDisable.svg";
import Imagebrand from "../../assets/images/imag.svg";
import Lancetbrand from "../../assets/images/lancet.svg";
import ECHOLAB from "../../assets/images/logos1.svg";
import Synlab from "../../assets/images/logos4.svg";
import { Toast } from "../../components";
import LoaderComponent from "../../components/Loading/LoaderComponent";
import Layout from "../../layout";
import axios from "axios";
import {
  clearCart,
  getCartItems,
  getRelatives,
} from "../../redux/cart/CartAction";
import { updateCart, updatePackageCart } from "../../redux/cart/CartServices";
import IndividualItem from "./components/IndividualItem";
import PackageIndividualItem from "./components/PackageIndividualItem";
import AddAddress from "./components/pop-ups/AddAddress";
import AddRelative from "./components/pop-ups/AddRelative";
import "./styles.scss";
import { Grid } from "@material-ui/core";
import Closeicon from "../../../src/assets/images/SheetClose.svg";
import { getFirebaseAnalyticsInstance } from "../../firebase";
import ReactGA from 'react-ga';

export default function CartPreviewPage() {
  let history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const cartState = useSelector((state) => state.cartsData);
  const [toast, setToast] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [addRelative, setAddRelative] = useState(false);
  const [addressPopup, setAddressPopup] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [address, setAddress] = useState();
  const [selectedAddressRelative, setSelectedAddressRelative] = useState();
  const [isPackageCart, setIsPackageCart] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const [labwiseAddress, setLabWiseAdddress] = useState([
    { partnerName: "", addresses: [] },
  ]);
  const [labwiseAddressToSend, setLabWiseAdddressToSend] = useState([]);

  const [homesampleQuantity, setHomesampleQuantity] = useState();
  // List of selected array
  const [selectedAddressArray, setSelectedAddressArray] = useState([]);
  const [itemWithMultipleRecipient, setItemWithMultipleRecipient] = useState(
    []
  );

  const [isHomeServiceAdded, setHomeServiceAdded] = useState(false);
  const [checkedAddressList, setCheckedAddressList] = useState([{}]);
  const [cartCount, setCartCount] = useState(0);
  const [cityId, setCityId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 768
        ? setMobileView(true)
        : setMobileView(false);
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(clearCart());
    dispatch(getCartItems());
    dispatch(getRelatives());
    setCheckedAddressList([]);
  }, []);

  const CartListUpdate = () => {
    dispatch(getCartItems());
    console.log('enter........')
  }

  useEffect(() => {
    setLabWiseAdddressToSend([]);
    setLabWiseAdddress([]);
  }, []);

  useEffect(() => {
    const filtered = labwiseAddress.filter((el) => {
      return (
        el.partnerName !== null &&
        typeof el.partnerName !== "undefined" &&
        el.partnerName !== "" &&
        el.partnerName !== false
      );
    });

    const addressFilter = filtered.filter((el) => {
      return el.addresses.length > 0;
    });

    let newData = [];
    addressFilter &&
      addressFilter.forEach((item) => {
        item.addresses.forEach((add) => {
          let obj = add.data;
          obj["lab_partner_name"] = add.labName;
          newData.push(obj);
        });
      });
    setLabWiseAdddressToSend(newData);
  }, [labwiseAddress]);

  useEffect(() => {
    setItemWithMultipleRecipient([]);
    let testCount = 0;
    cartState.data &&
      cartState.data.shoppinglist &&
      cartState.data.shoppinglist.forEach((item) => {
        if (item.type === "test") {
          item.data.forEach((item) => {
            testCount = testCount + 1;
            if (item.name === "Home Service Charge") {
              let updatedItemValues = item;
              let quantity = 1;
              updatedItemValues["quantity"] = quantity;
              setItemWithMultipleRecipient((prev) => [
                ...prev,
                updatedItemValues,
              ]);
            } else {
              item &&
                item.patient_name &&
                Array.isArray(item.patient_name) &&
                item.patient_name.forEach((itemd, index) => {
                  let updatedItemValues = item;
                  // updatedItemValues['quantity'] = item.quantity
                  setItemWithMultipleRecipient((prev) => [
                    ...prev,
                    updatedItemValues,
                  ]);
                });
            }
          });
        } else if (item.type === "package") {
          setIsPackageCart(true);
          testCount = 1;
        }
      });
    setCartCount(testCount);
  }, [cartState]);

  useEffect(() => {
    cartState.data &&
      cartState.data.shoppinglist &&
      cartState.data.shoppinglist.length > 0 &&
      cartState.data.shoppinglist.forEach((item, index) => {
        item.data.forEach((cartItem) => {
          if (
            cartItem.name === "Home Service Charge" ||
            cartItem.home_service_included === "yes"
          ) {
            setHomeServiceAdded(true);
          }
        });
      });
  }, [cartState]);

  const handleAddressPopup = () => {
    window.scroll(0, 500);
    setAddressPopup(true);
  };

  const handleRelativePopup = () => {
    window.scroll(0, 500);
    setAddRelative(true);
  };

  const handleUpdatedData = (updatedValues, id, quantity) => {
    let formatedObject = updatedValues;

    formatedObject["patient_uuid"] = updatedValues.patient_uuid.filter((el) => {
      return el !== null && typeof el !== "undefined" && el !== "";
    });

    const cartItemIndex = itemWithMultipleRecipient.findIndex(
      (item) => item.uuid === id
    );

    const updatedState = [...itemWithMultipleRecipient];
    if (cartItemIndex !== -1) {
      updatedState[cartItemIndex] = formatedObject;
      setItemWithMultipleRecipient(updatedState);
    } else {
      setItemWithMultipleRecipient((prev) => [...prev, formatedObject]);
    }
  };

  const handleSubmit = () => {
    try {
      if (cartCount === 0) {
        setErrorText("Cart is empty");
        setToast(true);
        throw new Error("Failed");
      } else {
        const uniqueUpdatedList = Array.from(
          new Set(itemWithMultipleRecipient.map((a) => a.uuid))
        ).map((id) => {
          return itemWithMultipleRecipient.find((a) => a.uuid === id);
        });
        if (
          uniqueUpdatedList.length <= 0 ||
          uniqueUpdatedList.length !== cartCount
        ) {
          setErrorText(
            "Please Update all test with Recipient and required quantity"
          );
          setToast(true);
        } else {
          uniqueUpdatedList &&
            uniqueUpdatedList.forEach((item) => {
              setHomesampleQuantity(item && item.quantity);
              if (
                item.isRecommendedTest !== true &&
                item.uuid.startsWith("LPT") &&
                item.patient_uuid.length !== item.quantity
              ) {
                setErrorText(
                  `Test Quantity and added recipients does not match for ${item.name}`
                );
                setToast(true);
                throw new Error("Failed");
              }
            });

          updateCartItems(uniqueUpdatedList);
          // getFirebaseAnalyticsInstance().logEvent('Cart Items',  uniqueUpdatedList)
          ReactGA.event({
            category: 'Cart Items',
            action: uniqueUpdatedList,
            label: 'Cart Items',
          })
        }
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const updateCartItems = async (payLoad) => {
    try {
      setLoader(true);

      let cartId =
        cartState.data.fulldetails &&
        cartState.data.fulldetails[0] &&
        cartState.data.fulldetails[0].uuid;

      let requestBody = payLoad;

      let patientNames = payLoad[0].patient_name;
      let patientUUIDs = payLoad[0].patient_uuid;

      if (isPackageCart) {
        requestBody = payLoad[0].items.map((item) => {
          return {
            ...item,
            quantity: 1,
            patient_name: patientNames,
            patient_uuid: patientUUIDs,
          };
        });
      }

      let response = await updateCart(
        requestBody,
        cartId,
        labwiseAddressToSend
      );

      setLoader(false);
      dispatch(clearCart());
      history.push({
        pathname: "/shoppingCart",
        state: {
          realtive: null,
          myself: null,
          addressData: address,
          savedAddress: selectedAddressRelative,
          homeSampleAddress: checkedAddressList,
        },
      });
    } catch (error) {
      setLoader(false);
      if (error && error.response && error.response.data) {
        setErrorText("" + error.response.data.message);
        setToast(true);
        setLoader(false);
      }
    }
  };

  const handleDeliveryAddress = (list) => {
    let p_name =
      list.length > 0 && list[0].labName
        ? list[0].labName
        : cartState.data.shoppinglist[0].data[0].lab_partner_name;
    let data = [];
    let formatedData = { partnerName: p_name, addresses: list };
    let p = labwiseAddress.filter((x) => x.partnerName === p_name);

    if (p.length > 0) {
      let indexToUpdate = labwiseAddress.findIndex(
        (lab) => lab.partnerName === p_name
      );
      const updatedState = [...labwiseAddress];
      if (list && list[0] && list[0].name && list[0].name) {
        updatedState[indexToUpdate].addresses = list;
      } else {
        updatedState[indexToUpdate].addresses = [];
      }
      setLabWiseAdddress(updatedState);
    } else {
      setLabWiseAdddress((prev) => [...prev, formatedData]);
    }
  };

  const renederIndividualComponet = (cartItem, position) => {
    let data = [];
    if (cartItem.type === "test") {
      // getFirebaseAnalyticsInstance().logEvent('Selected Tests', cartState.data.shoppinglist &&
      // cartState.data.shoppinglist[position].data)
      ReactGA.event({
        category: 'Selected Tests',
        action: cartState.data.shoppinglist &&
          cartState.data.shoppinglist[position].data,
        label: 'Selected Tests',
      })
    }
    else if (cartItem.type === 'package') {
      // getFirebaseAnalyticsInstance().logEvent('Selected Tests',  cartItem.details[0])

      ReactGA.event({
        category: 'Selected Tests',
        action: cartItem.details[0],
        label: 'Selected Tests',
      })
    }
    if (cartItem.type === "test") {
      cartState.data.shoppinglist &&
        cartState.data.shoppinglist[position].data.forEach((item, index) => {
          data.push(
            <IndividualItem
              itemDetails={item}
              recipients={cartState && cartState.relatives}
              cartUUID={
                cartState.data.fulldetails &&
                cartState.data.fulldetails[0] &&
                cartState.data.fulldetails[0].uuid
              }
              cartlistUpdateApi = {() => CartListUpdate()}
              indexx={index}
              errotText={(text) => setErrorText(text)}
              errotToast={(text) => setToast(true)}
              mobileView={mobileView}
              updateItems={(updatedValues, id, quantity) => {
                handleUpdatedData(updatedValues, id, quantity);
              }}
              checkedAddressList={checkedAddressList}
              addressCallBack={(event) => handleDeliveryAddress(event)}
            />
          );
        });
    } else if (cartItem.type === "package") {
      data.push(
        <PackageIndividualItem
          itemDetails={cartItem.details[0]}
          packageDetails={cartItem.details[0].package_details[0]}
          recipients={cartState && cartState.relatives}
          cartUUID={
            cartState.data.fulldetails &&
            cartState.data.fulldetails[0] &&
            cartState.data.fulldetails[0].uuid
          }
          indexx={position}
          errotText={(text) => setErrorText(text)}
          errotToast={(text) => setToast(true)}
          mobileView={mobileView}
          updateItems={(updatedValues, id, quantity) => {
            handleUpdatedData(updatedValues, id, quantity);
          }}
          checkedAddressList={checkedAddressList}
          addressCallBack={(event) => handleDeliveryAddress(event)}
        />
      );
    }

    return data;
  };

  const handleCheckedAddressArray = (addressDetails) => {
    let position = addressDetails.itemPosition;
    let id = addressDetails.addressData._id;
    let duplicateIndex = _.findIndex(checkedAddressList, function (o) {
      return o._id == id;
    });

    if (duplicateIndex == -1) {
      let completeAddressDetails = addressDetails.addressData;
      completeAddressDetails["city"] = cityId;
      completeAddressDetails["area"] = areaId;
      completeAddressDetails["patient_uuid"] =
        cartState && cartState.relatives[position].uuid;
      completeAddressDetails["phoneNumber"] =
        cartState && cartState.relatives[position].mobile;
      completeAddressDetails["email"] =
        cartState && cartState.relatives[position].email;
      completeAddressDetails["patient_name"] =
        cartState && cartState.relatives[position].full_name;
      setCheckedAddressList((prev) => [...prev, completeAddressDetails]);
    } else {
      var newArray = [...checkedAddressList];
      let completeAddressDetails = addressDetails.addressData;
      completeAddressDetails["city"] = cityId;
      completeAddressDetails["area"] = areaId;
      completeAddressDetails["patient_uuid"] =
        cartState && cartState.relatives[position].uuid;
      completeAddressDetails["phoneNumber"] =
        cartState && cartState.relatives[position].mobile;
      completeAddressDetails["email"] =
        cartState && cartState.relatives[position].email;
      completeAddressDetails["patient_name"] =
        cartState && cartState.relatives[position].full_name;

      var index = newArray.indexOf(completeAddressDetails);
      if (index !== -1) {
        newArray.splice(index, 1);
        setCheckedAddressList(newArray);
      }
    }
  };


  const [partner, setPartner] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/metadata/partner/getpartner`)
      .then((res) => {
        setPartner(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  var array3 = [];
  cartState.data &&
    cartState.data.shoppinglist &&
    cartState.data.shoppinglist.length > 0 && cartState.data.shoppinglist.map((i, index) => {
      console.log(i, "jjkk")
      for (var i1 = 0; i1 < partner.length; i1++) {
        if (partner[i1].uuid === i.data[0].partner_uuid) {
          array3.push(partner[i1]);

        }
      }

    })



  const phoneNumber = "+2349010996000";
  const boldStyle = {
    fontWeight: 'bold',
    cursor: "grab",
    color: "#ff5c3c"
  };

  const handleWhatsAppClick = (event) => {
    console.log(event, "click on the whatsapp num")
    const formattedPhoneNumber = phoneNumber.replace(/\D/g, ''); // Remove any non-numeric characters
    const whatsappLink = `https://api.whatsapp.com/send?phone=${formattedPhoneNumber}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <Layout>
      <Helmet>
        <title>doctall.diagnostics.com | Cart Preview
        </title>
        <meta
          name='description'
          content='Compare prices from the best diagnostic centres around you. Shop for tests, buy at discounted rates and receive results online'
        />
      </Helmet>
      <>
        <div className="shopping-cart-container">
          <div className="header-row">
            {!mobileView ? <img src={HomeDisable} alt="HomeDisable" /> : <></>}
            {mobileView === false ? (
              <>
                <img src={DisableRight} alt="DisableRight" />
                <div
                  className="disable-font"
                  onClick={() => {
                    isPackageCart
                      ? history.push("/popularpackages")
                      : history.push("/populartest");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {isPackageCart ? `Popular Packages` : `Popular Tests`}
                </div>
                <img src={DisableRight} alt="DisableRight" />
                <div
                  className="disable-font"
                  onClick={() => {
                    history.push({
                      pathname: "/compareprice",
                      state: JSON.parse(
                        localStorage.getItem("COMPAREPRICEDATA")
                      ),
                    });
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Compare Prices
                </div>
                <img src={DisableRight} alt="DisableRight" />
                <div className="header-text" style={{ color: "#163E8C" }}>
                  {/* Cart Preview */}
                  Add Recipients
                </div>
              </>
            ) : (
              <>
                <svg
                  width="9"
                  height="20"
                  viewBox="0 0 9 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => history.goBack()}
                >
                  <path
                    d="M8.00019 0.00068029C8.12412 0.000680294 8.24805 0.0481132 8.34258 0.142645C8.53164 0.331708 8.53164 0.638352 8.34258 0.827749L1.16986 8.0008L5.93753 12.7688C6.12659 12.9579 6.12659 13.2645 5.93753 13.4539C5.74847 13.643 5.44182 13.643 5.25243 13.4539L0.142038 8.34352C-0.0470249 8.15445 -0.0470249 7.84781 0.142038 7.65841L7.65747 0.142645C7.75234 0.0481131 7.87627 0.000680286 8.00019 0.00068029Z"
                    fill="#163E8C"
                  />
                </svg>

                <div className="nav-font" onClick={() => history.goBack()}>
                  Back
                </div>
              </>
            )}
          </div>
          <div className="wrapper-cls">
            <div className="left-container">
              <div className="headers-cls">
                <div className="header-font">Cart Preview</div>
              </div>
              {!mobileView ? (
                <div className="headers-cls" style={{ marginTop: "24px" }}>
                  <div className="header-font">
                    <Button
                      className="font-class"
                      style={{
                        color: "white",
                        backgroundColor: "#FF5C3C",
                        borderColor: "#FF5C3C",
                        marginRight: "5px",
                      }}
                      onClick={handleRelativePopup}
                    >
                      Add Relative
                    </Button>
                    {isHomeServiceAdded && (
                      <Button
                        className="font-class"
                        style={{
                          color: "white",
                          backgroundColor: "#FF5C3C",
                          borderColor: "#FF5C3C",
                        }}
                        onClick={handleAddressPopup}
                      >
                        Add Address
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}
              {mobileView ? (
                <div className="headers-cls">
                  <div className="header-font">
                    <Button
                      className="font-class"
                      style={{
                        color: "white",
                        backgroundColor: "#FF5C3C",
                        borderColor: "#FF5C3C",
                        marginRight: "5px",
                      }}
                      onClick={handleRelativePopup}
                    >
                      Add Relative
                    </Button> &nbsp;&nbsp;&nbsp;
                    {isHomeServiceAdded && (
                      <Button
                        className="font-class"
                        style={{
                          color: "white",
                          backgroundColor: "#FF5C3C",
                          borderColor: "#FF5C3C",
                        }}
                        onClick={handleAddressPopup}
                      >
                        Add Address
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}

              <div className="top-divider"></div>
              <div className="shop-cart-out">
                <div className="shopping-cart-outer-container">
                  <div className="header-container-top">
                    <div className="font-cls" style={{ fontWeight: "bold" }}>DIAGNOSTIC TEST</div>
                  </div>
                  <div className="selected-test-container-out">
                    <div className="selected-test-container" >
                      {cartState.data &&
                        cartState.data.shoppinglist &&
                        cartState.data.shoppinglist.length > 0
                        ? cartState.data.shoppinglist.map((i, index) => {
                          console.log(i, "jjkk")
                          return (
                            <>
                              {/* <img
                                  className="partner-logo"
                                  src={
                                    i.data &&
                                    i.data[0] &&
                                    i.data[0].lab_partner_name &&
                                    i.data[0].lab_partner_name === "ECHOLAB"
                                      ? ECHOLAB
                                      : i.data[0].lab_partner_name ===
                                        "UNION DIAGNOSTICS"
                                      ? BrandImage
                                      : i.data[0].lab_partner_name === "SYNLAB"
                                      ? Synlab
                                      : i.data[0].lab_partner_name ===
                                        "IMAGE DIAGNOSTICS"
                                      ? Imagebrand
                                      : i.data[0].lab_partner_name ===
                                        "DNA LABS"
                                      ? Dnabrand
                                      : i.data[0].lab_partner_name === "CLINIX"
                                      ? Clinixbrand
                                      : i.data[0].lab_partner_name ===
                                        "CLINA LANCET"
                                      ? Lancetbrand
                                      : i.data[0].lab_partner_name ===
                                        "AFRIGLOBAL"
                                      ? Afribrand
                                      : i.data[0].lab_partner_name === "ARRIVE ALIVE"
                                      ? arivealive
                                      : i.data[0].lab_partner_name === "BROADPLACES"
                                      ? broadplace
                                      : null
                                  }
                                  alt="BrandImage"
                                /> */}
                              {/* {array3.map((item) => {
                  return <img src={item.logo}></img>;
                })} */}
                              {<img src={array3 && array3[index] && array3[index].logo} style={{ width: "150px", height: "auto", paddingLeft: "10px" }}></img>}
                              <div
                                className="top-header-row-out"
                                style={{ marginTop: "5%" }}
                              >
                                <div className="col-md-4">
                                  <div>
                                    {isPackageCart
                                      ? `Lab package`
                                      : `DIAGNOSTIC TEST`}
                                  </div>
                                </div>
                                {!mobileView ? (
                                  <div className="col-md-2" >
                                    <div style={{ marginLeft: "24px", fontWeight: "bold" }}>QUANTITY</div>
                                  </div>
                                ) : (
                                  <></>
                                )}

                                <div className="col-md-2">
                                  <div style={{ fontWeight: "bold" }}>AMOUNT</div>
                                </div>
                                {!mobileView ? (
                                  <div className="col-md-4">
                                    <div style={{ fontWeight: "bold" }}>WHO IS THE TEST FOR?</div>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>

                              <div className="selected-test-align">
                                {renederIndividualComponet(i, index)}
                              </div>
                            </>
                          );
                        })
                        : null}

                      {/* {isHomeServiceAdded && (
                        <AddressComponent
                          cartId={
                            cartState.data.fulldetails &&
                            cartState.data.fulldetails[0] &&
                            cartState.data.fulldetails[0].uuid
                          }
                          recipients={cartState && cartState.relatives}
                          selectedAddressValue={(values) => setAddress(values)}
                          selectedRelativeAddress={(values) =>
                            setSelectedAddressRelative(values)
                          }
                          parentSelectedAddressArray={(values) => {
                            setSelectedAddressArray(values);
                          }}
                          addressChecked={(values) => {
                            handleCheckedAddressArray(values);
                          }}
                          errotText={(text) => setErrorText(text)}
                          errotToast={(text) => setToast(true)}
                          parentAreaId={(event) => setAreaId(event)}
                          parentCityId={(event) => setCityId(event)}
                        />
                      )} */}

                      {/* <RecipientAddress /> */}
                    </div>
                    <div
                      style={{ display: "flex", justifyContent: "center", marginTop: "0px" }}
                    >
                      <div className="headers-cls" style={{ marginTop: "0px", color: "#fff" }}>
                        {cartState.loader ? (
                          <div
                            className="back-cont-out"
                            style={{ cursor: "wait" }}
                          >
                            <span>Updating Cart..</span>
                          </div>
                        ) : (
                          <div
                            className="back-cont-out"
                            style={{ cursor: "pointer", backgroundColor: "#FF5C3C", color: "white", marginBottom: "20px", marginTop: "0px" }}
                            onClick={handleSubmit}
                          >
                            <span>Confirm Order</span>
                            {/* <span>PROCEED TO CHECKOUT</span> */}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
            <Toast
              text={errorText}
              type="error"
              open={toast}
              setClose={() => {
                setToast(false);
              }}
            />

            <button className="fixedButton" onClick={handleButtonClick}>

              <svg xmlns="http://www.w3.org/2000/svg" height="2em" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16" id="IconChangeColor"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" id="mainIconPathAttribute" fill="#ffffff"></path> </svg>
            </button>

            {/* Popup */}
            {showPopup && (
              <div className="popup">
                <p>We're here to assist you! If you have any difficulties finding tests, locating a lab, or have any questions, feel free to reach out to us on WhatsApp at {''}<a target="" onClick={handleWhatsAppClick} style={boldStyle}>{phoneNumber}</a>. Our team is ready to help you find the right diagnostic solutions and ensure a smooth experience.</p>
                <button className="popupButton" onClick={closePopup}>Close</button>
              </div>
            )}

            <Modal
              backdrop="static"
              show={addRelative}
              onHide={() => setAddRelative(false)}
            >

              <div className="parentContainer"
              // style={{padding:"0% 0% 8% 8%"}}
              >
                <Grid align="right">
                  <img src={Closeicon} alt="close icon" style={{ paddingBottom: "10px", width: "40px", cursor: "pointer" }} onClick={() => setAddRelative(false)} />
                </Grid>
                <AddRelative
                  close={() => setAddRelative(false)}
                  errotText={(text) => setErrorText(text)}
                  errotToast={(text) => setToast(true)}
                />
              </div>
            </Modal>

            <Modal
              backdrop="static"
              show={addressPopup}
              onHide={() => setAddressPopup(false)}
            >
              {/* <Grid align="right">
                <img src={Closeicon} alt="close icon" style={{paddingBottom:"10px", width:"40px"}} onClick={()=>setAddRelative(false)}/>
              </Grid> */}
              <AddAddress
                close={() => setAddressPopup(false)}
                cartId={
                  cartState.data &&
                  cartState.data.fulldetails &&
                  cartState.data.fulldetails[0] &&
                  cartState.data.fulldetails[0].uuid
                }
                recipients={cartState && cartState.relatives}
              />
            </Modal>
          </div>
        </div>
        {cartState.loader && <LoaderComponent />}
        {loader && <LoaderComponent />}
      </>
    </Layout>
  );
}
